import React from 'react'
import {useIntl} from 'react-intl'
import {InsightsResponse} from '@findhotel/sapi/dist/types/packages/core/src/insights'
import {reviewMessages} from 'components/Reviews/ReviewMessages'

import {Box} from '@vio/atlas/helpers/Box'
import {Button} from '@vio/atlas/src/components/designSystem/Button'
import {Icon} from '@vio/atlas/src/components/designSystem/Icon'
import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {AiPoweredReviewsCategoryCard} from '../AiPoweredReviewsCategoryCard'
import {AiPoweredReviewsFeedback} from '../AiPoweredReviewsFeedback'
import {aiReviewsMessages} from '../constants'
import {getSplitOverall} from '../utils'

interface Props {
  details: InsightsResponse
  onSelectCategory: (category: string) => void
  onShowAllReviews: () => void
}
export const AiPoweredSummaryOverall: React.FC<Props> = ({
  details,
  onSelectCategory,
  onShowAllReviews
}) => {
  const {formatMessage} = useIntl()
  const {isMobile} = useDeviceLayout()

  const splitOverall = getSplitOverall(details?.overall)

  return (
    <Box marginBottom="109px" desktopXs={{marginBottom: 's000'}}>
      <Box
        display="flex"
        flexDirection="row"
        gap="s200"
        marginBottom="s500"
        alignItems="center"
      >
        <Icon name="Sparkles" colorPath="content.brand.primary" size="lg" />
        <Text variant={isMobile ? 'titleL' : 'titleXL'} tag="p">
          {formatMessage(aiReviewsMessages.aiPoweredSummarySectionTitle)}
        </Text>
      </Box>

      <Box marginBottom="s600" display="flex" flexDirection="column" gap="s300">
        {splitOverall.map((paragraph, index) => (
          <Text key={['overall', index].join('-')} variant="bodyM">
            {paragraph}
          </Text>
        ))}
      </Box>
      <Box
        display="grid"
        gridTemplateColumns="repeat(2, 1fr)"
        gap="s300"
        desktopMd={{gridTemplateColumns: 'repeat(3, 1fr)'}}
      >
        {details?.categorySummaries?.map(category => (
          <AiPoweredReviewsCategoryCard
            hasPadding
            onCategoryClick={() => onSelectCategory(category.category)}
            key={category.category}
            details={category}
          />
        ))}
      </Box>
      <Box paddingTop="s700">
        <Button
          variant="tertiary"
          fullWidth={isMobile}
          onClick={onShowAllReviews}
          size="lg"
        >
          <FormattedMessageWrapper {...reviewMessages.readAllReviews} />
        </Button>
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        paddingTop="s500"
        gap="s500"
        flexDirection="column"
        desktopXs={{flexDirection: 'row'}}
      >
        <AiPoweredReviewsFeedback sourceComponent="Overall" />
        <Box display="flex" alignItems="center" gap="s100">
          <Text variant="bodyXS" colorPath="content.neutral.secondary">
            {formatMessage(
              aiReviewsMessages.aiPoweredSummarySectionDescription
            )}
          </Text>
          <Icon
            name="Sparkles"
            size="sm"
            colorPath="content.neutral.secondary"
          />
        </Box>
      </Box>
    </Box>
  )
}
